// web-v2/src/lib/arStatus.js
//
// Browser copy of utils/ar-status.js (190 §1). The server derives the fact;
// these lists exist only so a sheet can filter a ledger it already holds
// without a round trip. tests/ar-financed.test.js asserts both lists equal
// the server's member for member, so the copy cannot drift silently.
//
// isObligationSettled: the client owes nothing more (deferred is in it BY RULE).
// isSettledByAnswer:   an answer a later payment may not overwrite (deferred is not).

export const OBLIGATION_SETTLED = Object.freeze(['succeeded', 'waived', 'deferred', 'financed']);
export const SETTLED_BY_ANSWER = Object.freeze(['succeeded', 'waived', 'financed']);

// ar_financed_by is a lowercase slug; the ledger prints a name. Same map as
// utils/ar-status.js FINANCE_COMPANY_NAMES, pinned by the same guard.
export const FINANCE_COMPANY_NAMES = Object.freeze({ ascend: 'Ascend' });
export function financeCompanyName(slug) {
  const s = String(slug || '').trim().toLowerCase();
  if (!s) return '';
  return FINANCE_COMPANY_NAMES[s] || (s.charAt(0).toUpperCase() + s.slice(1));
}

export function isObligationSettled(status) {
  return OBLIGATION_SETTLED.includes(status);
}

export function isSettledByAnswer(status) {
  return SETTLED_BY_ANSWER.includes(status);
}
